var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1517 277L1517 305",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1517.5,
    cy: 272.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1512.99 272.19C1512.99 268.283 1516.29 265.117 1520.36 265.117C1520.94 265.117 1521.51 265.184 1522.06 265.308C1520.74 264.48 1519.19 264 1517.52 264C1512.81 264 1509 267.806 1509 272.5C1509 277.194 1512.81 281 1517.52 281C1519.81 281 1521.89 280.093 1523.43 278.62C1522.49 279.032 1521.45 279.263 1520.36 279.263C1516.29 279.263 1512.99 276.096 1512.99 272.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1526.4 271.6L1526.37 269.146L1524.54 270.719L1522.3 270.056L1523.11 272.337L1521.77 274.381L1524.1 274.218L1525.5 276.144L1526.13 273.763L1528.34 272.909L1526.4 271.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch5);
export default __webpack_public_path__ + "static/media/church_5.a91cb1f5c9885c97adc8d48bdcbe3685.svg";
export { ForwardRef as ReactComponent };